enum GoogleAnalyticsEnum {
    Mock = "G-11HBNM4QMV",
    MeasurementID = ""
}

export default GoogleAnalyticsEnum;